export { default as SimpleTag } from './simple-tag';
export type { SimpleTagProps } from './simple-tag';
export { default, default as RemovableTag } from './removable-tag';
export type { RemovableTagProps } from './removable-tag';
export { default as AvatarTag } from '../tag-new/avatar-tag';
export type { AvatarTagProps } from '../tag-new/avatar-tag';
